import { QualitativeConfigApi } from 'src/app/models/jurisdictionRiskConfig.model';

export interface QualitativeDimensionLabels {
    exceedanceLabel: string;
    frequencyLabel: string;
}

export function parseQualitativeDimensionLabels(
    rawConfig: string | undefined,
    defaults: QualitativeDimensionLabels,
): QualitativeDimensionLabels {
    if (!rawConfig) {
        return defaults;
    }

    try {
        const parsed = JSON.parse(rawConfig) as QualitativeConfigApi;
        const dimensions = Array.isArray(parsed?.dimensions) ? parsed.dimensions : [];
        return {
            exceedanceLabel: dimensions[0]?.name || defaults.exceedanceLabel,
            frequencyLabel: dimensions[1]?.name || defaults.frequencyLabel,
        };
    } catch {
        return defaults;
    }
}
